import { gql } from 'apollo-angular';
import { sharedViewerFragment, sharedViewerWithAvatarFragment } from './shared-viewer.fragments';

export const sharedViewerQuery = gql`
  query SharedViewer {
    viewer {
      ...SharedViewer
    }
  }
  ${sharedViewerFragment}
`;

export const sharedViewerWithAvatarQuery = gql`
  query SharedViewerWithAvatar {
    viewer {
      ...SharedViewerWithAvatar
    }
  }
  ${sharedViewerWithAvatarFragment}
`;

export const sharedViewerWithOidcQuery = gql`
  query SharedViewerWithOidc {
    viewer {
      id
      oidc {
        id
        oidcProvider
        expiresAt
        userinfo
      }
    }
  }
`;
